import { ReactComponent as kitchen } from '@/components/icons/kitchen.svg';
import { ReactComponent as laundry } from '@/components/icons/laundry.svg';
import { ReactComponent as bathroom } from '@/components/icons/bathroom.svg';
import { ReactComponent as bedroom } from '@/components/icons/bedroom.svg';
import { ReactComponent as mudroom } from '@/components/icons/mudroom.svg';
import { ReactComponent as other } from '@/components/icons/other.svg';



//////    for collection nevigation

export const PROJECT_TYPE_ICONS = [
    {flow: 'kitchen', icon: kitchen},
    {flow: 'laundry', icon: laundry},
    {flow: 'bathroom', icon: bathroom},
    {flow: 'bedroom', icon: bedroom},
    {flow: 'mudroom', icon: mudroom},
    {flow: 'other', icon: other},
    ];


//////    for additional info config

export const AVAILABLE_ROOM_TYPES = [
    { id: 'kitchen', label: 'Kitchen' },
    { id: 'bathroom', label: 'Bathroom' },
    { id: 'laundry', label: 'Laundry' },
    { id: 'mudroom', label: 'Mudroom' },
    { id: 'bedroom', label: 'Bedroom' },
    { id: 'default', label: 'Default' },
    { id: 'other', label: 'Other' },
    // { id: 'living_room', label: 'Living Room' },
    // { id: 'dining_room', label: 'Dining Room' },
    // { id: 'office', label: 'Office' }
    ];


    // export const AVAILABLE_ROOM_TYPES = [
    //     { id: 'kitchen', label: 'Kitchen' },
    //     { id: 'bathroom', label: 'Bathroom' },
    //     { id: 'bedroom', label: 'Bedroom' },
    //     { id: 'livingroom', label: 'Living Room' },
    //     { id: 'diningroom', label: 'Dining Room' },
    //     { id: 'laundry', label: 'Laundry Room' },
    //     { id: 'mudroom', label: 'Mudroom' },
    //     { id: 'office', label: 'Home Office' },
    //     { id: 'garage', label: 'Garage' },
    //     { id: 'basement', label: 'Basement' },
    //     { id: 'other', label: 'Other' }
    //   ];